import { createFileRoute } from '@tanstack/react-router';
import { ExamStatusPage } from '@/features/mockExams/guest/ExamStatusPage';
export const Route = createFileRoute('/exam-status')({ component: ExamStatusPage });
